import getStyles from "./styles";
import { useAppSelector } from "../../redux";
import type { IMainContainerProps } from "../../types";
import { selectTextDirection } from "../LanguageSelect/LanguageSelectSlice";
import { Avatar, Box, Grid, Paper, Typography } from "@mui/material";

export default function _MainContainer(props: IMainContainerProps) {
  const { children, avatar, title, titleVariant } = props;

  const styles = getStyles();

  const textDirection = useAppSelector(selectTextDirection);

  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={12}
      lg={12}
      xl={12}
      component={Paper}
      elevation={6}
      dir={textDirection}
      sx={{ boxShadow: "none", height: "100%" }}
    >
      <Box sx={styles.paper}>
        {avatar ? <Avatar sx={styles.avatar}>{avatar}</Avatar> : null}

        {title ? (
          <Typography component="h1" variant={titleVariant} sx={styles.title}>
            {title}
          </Typography>
        ) : null}
        {children}
      </Box>
    </Grid>
  );
}
